"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2665],{

/***/ 62665:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33616);
/* harmony import */ var hls_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75189);
/* harmony import */ var hls_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(hls_js__WEBPACK_IMPORTED_MODULE_1__);
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};


function ReactHlsPlayer(_a) {
    var hlsConfig = _a.hlsConfig, _b = _a.playerRef, playerRef = _b === void 0 ? react__WEBPACK_IMPORTED_MODULE_0__.createRef() : _b, src = _a.src, autoPlay = _a.autoPlay, props = __rest(_a, ["hlsConfig", "playerRef", "src", "autoPlay"]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        var hls;
        function _initPlayer() {
            if (hls != null) {
                hls.destroy();
            }
            var newHls = new (hls_js__WEBPACK_IMPORTED_MODULE_1___default())(__assign({ enableWorker: false }, hlsConfig));
            if (playerRef.current != null) {
                newHls.attachMedia(playerRef.current);
            }
            newHls.on((hls_js__WEBPACK_IMPORTED_MODULE_1___default().Events.MEDIA_ATTACHED), function () {
                newHls.loadSource(src);
                newHls.on((hls_js__WEBPACK_IMPORTED_MODULE_1___default().Events.MANIFEST_PARSED), function () {
                    var _a;
                    if (autoPlay) {
                        (_a = playerRef === null || playerRef === void 0 ? void 0 : playerRef.current) === null || _a === void 0 ? void 0 : _a.play().catch(function () {
                            return console.log('Unable to autoplay prior to user interaction with the dom.');
                        });
                    }
                });
            });
            newHls.on((hls_js__WEBPACK_IMPORTED_MODULE_1___default().Events.ERROR), function (event, data) {
                if (data.fatal) {
                    switch (data.type) {
                        case (hls_js__WEBPACK_IMPORTED_MODULE_1___default().ErrorTypes.NETWORK_ERROR):
                            newHls.startLoad();
                            break;
                        case (hls_js__WEBPACK_IMPORTED_MODULE_1___default().ErrorTypes.MEDIA_ERROR):
                            newHls.recoverMediaError();
                            break;
                        default:
                            _initPlayer();
                            break;
                    }
                }
            });
            hls = newHls;
        }
        if (hls_js__WEBPACK_IMPORTED_MODULE_1___default().isSupported()) {
            _initPlayer();
        }
        return function () {
            if (hls != null) {
                hls.destroy();
            }
        };
    }, [autoPlay, hlsConfig, playerRef, src]);
    if (hls_js__WEBPACK_IMPORTED_MODULE_1___default().isSupported())
        return react__WEBPACK_IMPORTED_MODULE_0__.createElement("video", __assign({ ref: playerRef }, props));
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement("video", __assign({ ref: playerRef, src: src, autoPlay: autoPlay }, props));
}
/* harmony default export */ __webpack_exports__["default"] = (ReactHlsPlayer);


/***/ })

}]);